module.exports = __webpack_public_path__ + "arrow.589dd6ad3b95ab97c3415282863fd7c2.png";